import { FC } from 'react';
import styled from 'styled-components';

const SummaryElement = styled.div`
  display: grid;
  grid-template-areas:
    'header'
    'subheader'
    'row';
  grid-template-rows: auto auto 1fr;
  transition: ${({ theme }) => theme.vars.transition.default};
`;

const SummaryHeader = styled.div`
  grid-area: header;
  justify-self: center;
  align-self: center;
  font-weight: 600;
  font-size: 35px;
  transition: ${({ theme }) => theme.vars.transition.default};
  color: ${({ theme }) => theme.vars.newColor.black};
`;

const SummarySubHeader = styled.div`
  grid-area: subheader;
  justify-self: center;
  align-self: center;
  margin-top: 15px;
  font-size: 18px;
  font-style: italic;
  color: ${({ theme }) => theme.vars.newColor.green2};
  transition: ${({ theme }) => theme.vars.transition.default};
`;

const SummaryViewRowElement = styled.div`
  align-items: center;
  margin-top: 40px;
  padding: 0px;
`;

export interface IProps {
  /** The heading of the Summary */
  heading?: string;
  /** The subheading of the Summary */
  subHeading?: string;
}

export const SummaryView: FC<IProps> = props => {
  return (
    <SummaryElement>
      <SummaryHeader>{props.heading}</SummaryHeader>
      <SummarySubHeader>{props.subHeading}</SummarySubHeader>
      <SummaryViewRowElement data-testid="summaryView">{props.children}</SummaryViewRowElement>
    </SummaryElement>
  );
};
